// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__3dXpl","withMobileMargins":"DateRangeInput_withMobileMargins__337iY","arrowIcon":"DateRangeInput_arrowIcon__2jtRO"};